module.exports = __webpack_public_path__ + "assets/staples-3e85b3310eca8f587173b0d19df9d13b.svg";